import { paths } from 'config'
import { Loadable } from 'shared/components'
import { ModuleRoute } from 'shared/types'

const routes: ModuleRoute[] = [
  {
    path: paths.security,
    exact: true,
    admin: false,
    component: Loadable({
      component: () => import('./pages/Security'),
    }),
    layoutSettings: {},
  },
  {
    path: paths.legacyChangePassword,
    exact: true,
    admin: false,
    component: Loadable({
      component: () => import('./pages/LegacyChangePasswordRedirect'),
    }),
    layoutSettings: {},
  },
]

export default routes
